export enum LeadSource {
  DIRECT = 'direct',
  WHATSAPP = 'whatsapp',
  WHATSAPP_ADS = 'whatsapp_ads',
  FACEBOOK_ADS = 'facebook_ads',
  INSTAGRAM_ADS = 'instagram_ads',
  GOOGLE_ADS = 'google_ads',
  LINKEDIN_ADS = 'linkedin_ads',
  YOUTUBE_ADS = 'youtube_ads',
  WEBSITE = 'website',
  SHOPIFY = 'shopify',
  BROADCAST = 'broadcast',
  ORGANIC_SOCIAL = 'organic_social',
  REFERRAL = 'referral',
  OTHER = 'other',
}

export const LEAD_SOURCE_LABELS: Record<LeadSource, string> = {
  [LeadSource.DIRECT]: 'Direct',
  [LeadSource.WHATSAPP]: 'WhatsApp',
  [LeadSource.WHATSAPP_ADS]: 'WhatsApp Ads',
  [LeadSource.FACEBOOK_ADS]: 'Facebook Ads',
  [LeadSource.INSTAGRAM_ADS]: 'Instagram Ads',
  [LeadSource.GOOGLE_ADS]: 'Google Ads',
  [LeadSource.LINKEDIN_ADS]: 'LinkedIn Ads',
  [LeadSource.YOUTUBE_ADS]: 'YouTube Ads',
  [LeadSource.WEBSITE]: 'Website',
  [LeadSource.SHOPIFY]: 'Shopify',
  [LeadSource.BROADCAST]: 'Broadcast',
  [LeadSource.ORGANIC_SOCIAL]: 'Organic Social',
  [LeadSource.REFERRAL]: 'Referral',
  [LeadSource.OTHER]: 'Other',
};

export const LEAD_SOURCE_OPTIONS = Object.entries(LEAD_SOURCE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export type CustomColumnType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'boolean'
  | 'date'
  | 'time'
  | 'datetime'
  | 'email'
  | 'phone'
  | 'url'
  | 'select'
  | 'multi_select';

export interface CustomColumnDefinition {
  key: string;
  name: string;
  type: CustomColumnType;
  options?: string[];
  is_active?: boolean;
}

export interface ColumnConfigItem {
  key: string;
  label?: string;
  is_default: boolean;
  order?: number;
  visible?: boolean;
  type?: CustomColumnType;
  options?: string[];
}

export interface LeadsTableConfig {
  columns: ColumnConfigItem[];
}

export interface Lead {
  id: string;
  name: string;
  phone: string;
  source: string;
  lead_status: string;
  created_at: string;
  updated_at?: string | null;
  conversation_id?: string | null;
  notes?: string | null;
  custom_fields?: Record<string, any>;
}
